import ProductTable from './src/main'

ProductTable.install = function (Vue) {
    Vue.component(ProductTable.name, ProductTable)
}

export default ProductTable